export enum ApiParamsKeys {
    Category = 'category_ids',
    Label = 'labels',
    Slug = 'slug',
    PageSize = 'page_size',
    PageNumber = 'page_number',
    ProductSlug = 'product_slug',
}
